<script>
import { mapGetters, mapState } from 'vuex'
import { breakpointsMixin } from '../../mixins/breakpointsMixin'
import { colorMixin } from '../../mixins/colorMixin'

export default {
  props: {
    component: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  mixins: [breakpointsMixin, colorMixin],
  mounted () {
    fetch(this.srcUrl)
      .then(response => response.text())
      .then(template => {
        const compiledTemplate = template
        this.htmlStuff = compiledTemplate
        const externalScript = document.createElement('script')
        externalScript.setAttribute('src', this.jsSrcUrl)
        externalScript.setAttribute('id', 'js-src')
        document.body.appendChild(externalScript)
      })
  },
  unmounted () {
    const specialScripts = document.getElementById('js-src')
    specialScripts.remove()
  },
  data () {
    return {
      htmlStuff: null,
      jsStuff: null
    }
  },
  computed: {
    ...mapState(['user', 'home', 'settings', 'challenges', 'challengePage']),
    ...mapGetters(['primaryColor', 'loggedIn']),
    srcUrl () {
      const baseURL = 'https://cdn.sanity.io/files/'
      const fileName = `${this.component.htmlFile.asset._ref.split('-')[1]}.${this.component.htmlFile.asset._ref.split('-')[2]}`
      const downloadURL = `${baseURL}${process.env.VUE_APP_SANITY_PROJECT_ID}/${process.env.VUE_APP_SANITY_DATA_SOURCE}/${fileName}`

      return downloadURL
    },
    jsSrcUrl () {
      const baseURL = 'https://cdn.sanity.io/files/'
      const fileName = this.component.scriptFile ? `${this.component.scriptFile.asset._ref.split('-')[1]}.${this.component.scriptFile.asset._ref.split('-')[2]}` : ''
      const downloadURL = `${baseURL}${process.env.VUE_APP_SANITY_PROJECT_ID}/${process.env.VUE_APP_SANITY_DATA_SOURCE}/${fileName}`

      return downloadURL
    }
  }
}
</script>

<template>
  <div v-html="htmlStuff">
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
